{
  const priceRangeInput = document.querySelectorAll('.price-range__input');
  priceRangeInput.forEach(e => {
    e.addEventListener('change', function() {
      const value = e.value;
      const target = document.getElementById(e.dataset.target);
      const step = e.step;
      if (e.dataset.target == 'price-min') {
        const maxValue = document.getElementById('Filter-価格-LTE').value ? document.getElementById('Filter-価格-LTE').value : e.max;
        console.log({maxValue});
        if (Number(maxValue) <= Number(value)) {
          console.log('maxValue <= value');
          e.value = Number(maxValue) - Number(step);
          document.getElementById('Filter-価格-GTE').value = Number(maxValue) - Number(step);
        } else {
          document.getElementById('Filter-価格-GTE').value = value;
        }
      } else {
        const minValue = document.getElementById('Filter-価格-GTE').value ? document.getElementById('Filter-価格-GTE').value : e.min;
        console.log({minValue});
        if (Number(minValue) >= Number(value)) {
          console.log('minValue >= value');
          e.value = Number(minValue) + Number(step);
          document.getElementById('Filter-価格-LTE').value = Number(minValue) + Number(step);
        } else {
          document.getElementById('Filter-価格-LTE').value = value;
        }
      }
      target.textContent = e.value;
    });
  });
}

// // js/common/form/price-range.js
// var PriceRangeCustomize = class extends HTMLElement {
//   #abortController;
//   connectedCallback() {
//     this.#abortController = new AbortController();
//     const rangeLowerBound = this.querySelector('input[type="range"]:first-child'), rangeHigherBound = this.querySelector('input[type="range"]:last-child'), textInputLowerBound = this.querySelector('input[name="filter.v.price.gte"]'), textInputHigherBound = this.querySelector('input[name="filter.v.price.lte"]');
//     textInputLowerBound.addEventListener("focus", () => textInputLowerBound.select(), { signal: this.#abortController.signal });
//     textInputHigherBound.addEventListener("focus", () => textInputHigherBound.select(), { signal: this.#abortController.signal });
//     textInputLowerBound.addEventListener("change", (event) => {
//       event.preventDefault();
//       event.target.value = Math.max(Math.min(parseInt(event.target.value), parseInt(textInputHigherBound.value || event.target.max) - 1), event.target.min);
//       rangeLowerBound.value = event.target.value;
//       rangeLowerBound.parentElement.style.setProperty("--range-min", `${parseInt(rangeLowerBound.value) / parseInt(rangeLowerBound.max) * 100}%`);
//     }, { signal: this.#abortController.signal });
//     textInputHigherBound.addEventListener("change", (event) => {
//       event.preventDefault();
//       event.target.value = Math.min(Math.max(parseInt(event.target.value), parseInt(textInputLowerBound.value || event.target.min) + 1), event.target.max);
//       rangeHigherBound.value = event.target.value;
//       rangeHigherBound.parentElement.style.setProperty("--range-max", `${parseInt(rangeHigherBound.value) / parseInt(rangeHigherBound.max) * 100}%`);
//     }, { signal: this.#abortController.signal });
//     rangeLowerBound.addEventListener("change", (event) => {
//       event.stopPropagation();
//       textInputLowerBound.value = event.target.value;
//       textInputLowerBound.dispatchEvent(new Event("change", { bubbles: true }));
//     }, { signal: this.#abortController.signal });
//     rangeHigherBound.addEventListener("change", (event) => {
//       event.stopPropagation();
//       textInputHigherBound.value = event.target.value;
//       textInputHigherBound.dispatchEvent(new Event("change", { bubbles: true }));
//     }, { signal: this.#abortController.signal });
//     rangeLowerBound.addEventListener("input", (event) => {
//       event.target.value = Math.min(parseInt(event.target.value), parseInt(textInputHigherBound.value || event.target.max) - 1);
//       event.target.parentElement.style.setProperty("--range-min", `${parseInt(event.target.value) / parseInt(event.target.max) * 100}%`);
//       textInputLowerBound.value = event.target.value;
//     }, { signal: this.#abortController.signal });
//     rangeHigherBound.addEventListener("input", (event) => {
//       event.target.value = Math.max(parseInt(event.target.value), parseInt(textInputLowerBound.value || event.target.min) + 1);
//       event.target.parentElement.style.setProperty("--range-max", `${parseInt(event.target.value) / parseInt(event.target.max) * 100}%`);
//       textInputHigherBound.value = event.target.value;
//     }, { signal: this.#abortController.signal });
//   }
//   disconnectedCallback() {
//     this.#abortController.abort();
//   }
// };
// if (!window.customElements.get("price-range")) {
//   window.customElements.define("price-range", PriceRangeCustomize);
// }